let initialState={payload:{msg:'fetching',data:[]},action:"success"};
let listInspection =(state=initialState.payload,action)=>{
    switch(action.type){
        case "success":{
            state={
                data:action.payload,
                msg:'fetched'
            };
            break;
        }
        default:{}

    }
return state;
}

export default listInspection;




// WEBPACK FOOTER //
// ./src/redux/reducers/vehicles/listInspection.js